import { render, staticRenderFns } from "./Storehouse.vue?vue&type=template&id=4d910fd0&scoped=true&"
import script from "./Storehouse.vue?vue&type=script&lang=js&"
export * from "./Storehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d910fd0",
  null
  
)

export default component.exports